import React, { FC } from "react";
import { IUserTrainingCourseSummary } from "src/@types/ImpiricaPlatformApi";
import { useFileManagement } from "src/hooks/useFileManagement";
import { Card } from "antd";
import { Icon } from "src/components/icons/Icon";
import { CircleCheck, CircleX, ArrowRight } from "lucide-react";
import Meta from "antd/lib/card/Meta";
import styles from "./ClientCourseCard.module.css";
import impirica_logo from "src/assets/images/Impirica Logo Square.png";

interface IProps {
	trainingCourse: IUserTrainingCourseSummary;
	onNavigate: any;
}

const ClientCourseCard: FC<IProps> = ({ trainingCourse, onNavigate }) => {
	const { getFileUrl } = useFileManagement();
	const thumbnailUrl = trainingCourse.imageUrl
		? getFileUrl(trainingCourse.imageUrl)
		: null;

	const _navigateToCourse = () => {
		onNavigate(trainingCourse);
	};
	const _getText = () => {
		if (trainingCourse.courseComplete) {
			return "Review course";
		} else if (
			trainingCourse.completedVideos > 0 ||
			trainingCourse.quizComplete
		) {
			return "Continue course";
		} else {
			return "Start course";
		}
	};

	return (
		<Card
			hoverable
			className={styles.clientCourseCard}
			onClick={_navigateToCourse}
			cover={
				<img
					className={styles.image}
					alt="logo"
					src={thumbnailUrl || impirica_logo}
				/>
			}
			actions={[
				<span key="start">
					{_getText()}{" "}
					{trainingCourse.courseComplete ? (
						<Icon className={styles.actionIcon} icon={CircleCheck} />
					) : (
						<Icon className={styles.actionIcon} icon={ArrowRight} />
					)}
				</span>,
			]}
		>
			<Meta
				title={trainingCourse.title}
				description={
					<div>
						<hr />
						<table className={styles.clientCourseVideoSummaryContainer}>
							<tbody>
								<tr>
									<td>
										<span data-testid="client-course-card-video-counts">
											{trainingCourse.completedVideos}/
											{trainingCourse.totalVideos} Videos
										</span>
									</td>
									<td>
										<Icon
											size="lg"
											className={styles.statusIcon}
											icon={
												trainingCourse.completedVideos &&
												trainingCourse.totalVideos &&
												trainingCourse.completedVideos /
													trainingCourse.totalVideos ===
													1
													? CircleCheck
													: CircleX
											}
										/>
									</td>
								</tr>
								<tr className={!trainingCourse.quizId ? styles.hidden : ""}>
									<td>Quiz</td>
									<td>
										<Icon
											size="lg"
											className={styles.statusIcon}
											icon={
												trainingCourse.quizComplete
													? CircleCheck
													: CircleX
											}
										/>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				}
			/>
		</Card>
	);
};

export default ClientCourseCard;
